import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import Form from '../common/Form';
import { del, post } from '../../utils/api';
import { activityDate2Human } from '../../utils/dateTime';
//
// Компонент выводит список дат мероприятия
//
const EventDates = ({ event }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
    const [ date, setDate ] = useState('');
    const [ error, setError ] = useState('');
	const [ dates, setDates ] = useState(event.dates ?? []);
    const [ showForm, setShowForm ] = useState(false);
    const [ isLoading, setIsLoading ] = useState(false);

    const add = () => {
        if(isLoading) return;
        setShowForm(true);
        setError('');
    };

    const create = async () => {
        setShowForm(false);
        setIsLoading(true);
        setError('');
        const result = await post(`/dates/${event._id}`, { date });
        if(result.error) {
            setError(t(result.error));
        } else {
			setDates(result.data.dates);
        }
        setIsLoading(false);
    };

    const remove = async (date) => {
        setShowForm(false);
        setIsLoading(true);
        setError('');
        const result = await del(`/dates/${event._id}`, { date });
        if(result.error) {
            setError(t(result.error));
        } else {
			setDates(result.data.dates);
        }
        setIsLoading(false);
    };

	return (
    <div>
        <h2>
            {t('eventview.dates')}
            <span onClick={() => add()}>{t('common.add')}</span>
        </h2>

        {error && <div className='error'>{error}</div>}
        {isLoading && <div className='success'>{t('common.loading')}</div>}

        {showForm &&
        <Form>
            <div className='Form-row'>
                <input
                    type='text'
                    value={date}
                    placeholder='YYYY-MM-DD HH:MM HH:MM'
                    onChange={e => setDate(e.target.value)}
                />
                <div
                    className='submit'
                    onClick={() => create()}
                >
                    <Icon icon={faPlus}/>
                </div>
                <div
                    className='button'
                    onClick={() => setShowForm(false)}
                >
                    <Icon icon={faTimes}/>
                </div>
			</div>
        </Form>}

        {dates.length > 0 ?
        <ul>
        {[...dates].sort().map((item, index) => (
            <li key={index}>
                {activityDate2Human(item, lang)}&nbsp;
                {!isLoading && <span className='a small' onClick={() => remove(item)}>{t('common.remove')}</span>}
            </li>
        ))}
        </ul> : <div>{t('eventview.nodates')}</div>}

    </div>
	);
};

EventDates.propTypes = {
    event: PropTypes.object.isRequired,
};

export default EventDates;
